import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";

function FiltersModal({setFilteredStudents,filtersModalDetails,showFiltersModal,setShowFiltersModal}) {

    // const [classes, setClasses] = useState([]);
    // const [sections, setSections] = useState([]);

    // console.log("filtersModalDetails",filtersModalDetails)
    // const uniqueClasses = []
    // for(let eachStudent of filtersModalDetails?.data){
    //     if(!uniqueClasses.includes(eachStudent.class)){
    //         uniqueClasses.push(eachStudent.class)
    //     }
    // }
    // const classValues = uniqueClasses.map(eachClass => {
    //     return {label: eachClass, value: eachClass}
    // })

    // const uniqueSections = []
    // for(let eachStudent of filtersModalDetails?.data){
    //     if(!uniqueSections.includes(eachStudent.section)){
    //         uniqueSections.push(eachStudent.section)
    //     }
    // }

    // const sectionValues = uniqueSections.map(eachSection => {
    //     return {label: eachSection, value: eachSection}
    // })

    const customStyles = {
        control: base => ({
          ...base,
          maxHeight: 150,
          overflow:"auto"
        })
      };

    // const handleChangeClasses = arr => {
    //     setClasses(arr)
    // };

    // const handleChangeRollNos = arr => {
    //     setSections(arr)
    // };

    // const filteredStudents = filtersModalDetails?.data?.filter(eachStudent => {
    //     const filteredClasses = classes.map(eachClass => eachClass.value)
    //     const filteredSections = sections.map(eachRollNo => eachRollNo.value)

    //     if(filteredClasses.length !== 0 && filteredSections.length !== 0){
    //         if(filteredClasses.includes(eachStudent.class) && filteredSections.includes(eachStudent.section)){
    //             return eachStudent
    //         }
    //     }else if(filteredClasses.length !== 0 && filteredSections.length === 0){
    //         if(filteredClasses.includes(eachStudent.class)){
    //             return eachStudent
    //         }
    //     }else if(filteredSections.length !== 0 && filteredClasses.length === 0){
    //         if(filteredSections.includes(eachStudent.section)){
    //             return eachStudent
    //         }
    //     }else{
    //         return eachStudent
    //     }
    // })

    // console.log("filteredStudents ::::::::::::", filteredStudents)
    // const onClickSave = () => {
    //     setFilteredStudents(filteredStudents)
    //     setShowFiltersModal(false)
    //     setClasses([])
    //     setSections([])
    // }

    const [classValue,setClassValue] =  useState("");
    const [classError,setClassError] = useState(false);
    const [isClassSelected,setIsClassSelected] = useState(false);

    const [sectionValue,setSectionValue] = useState("");
    const [sectionError,setSectionError] = useState(false);
    const [isSectionSelected,setIsSectionSelected] = useState(false);

    const [paymentStatusValue,setPaymentStatusValue] = useState("");
    const [paymentStatusError,setPaymentStatusError] = useState(false);
    const [isPaymentStatusSelected,setIsPaymentStatusSelected] = useState(false);

    const [termValue,setTermValue] = useState("");
    const [termError,setTermError] = useState(false);

    const uniqueClasses = []
    for(let eachStudent of filtersModalDetails?.data){
        if(!uniqueClasses.includes(eachStudent.class)){
            uniqueClasses.push(eachStudent.class)
        }
    }

    const classOptions = uniqueClasses.map(eachClass => {
        return {label: eachClass, value: eachClass}
    })

    const uniqueSections = []
    for(let eachStudent of filtersModalDetails?.data){
        if(!uniqueSections.includes(eachStudent.section) && eachStudent.class === classValue.value){
            uniqueSections.push(eachStudent.section)
        }
    }

    const sectionOptions = uniqueSections.map(eachSection =>{
        return {label: eachSection, value: eachSection}
    })

    const paymentStatusOptions = [{label:"Paid",value:"Paid"},{label:"Unpaid",value:"Unpaid"}]

    const uniqueTerms = []

    for (let eachStudent of filtersModalDetails?.data){
        if(eachStudent.class === classValue.value && eachStudent.section === sectionValue.value){
            eachStudent.termFee.map(eachObject => {
                if((eachObject[Object.keys(eachObject)[0]].paymentStatus === paymentStatusValue.value) && !uniqueTerms.includes(Object.keys(eachObject)[0])){
                    uniqueTerms.push(Object.keys(eachObject)[0])
                }
            })
        }
    }

    const termOptions = uniqueTerms?.map(eachTerm => {
        return {label: eachTerm.replace(" Fee",""), value: eachTerm}
    })

    const onChangeClass = (data) => {
        setClassValue(data)
        setSectionValue("")
        setIsClassSelected(true)
        setClassError(false)
        setIsSectionSelected(false)
        setIsPaymentStatusSelected(false)
    }

    const onChangeSection = (data) => {
        setSectionValue(data)
        setPaymentStatusValue("")
        setIsSectionSelected(true)
        setSectionError(false)
        setIsPaymentStatusSelected(false)
    }

    const onChangePaymentStatus = (data) => {
        setPaymentStatusValue(data) 
        setTermValue("")
        setIsPaymentStatusSelected(true)
        setPaymentStatusError(false)
    }

    const onChangeTerm = (data) => {
        setTermValue(data)
        setTermError(false)
    }

    const filteredStudents = filtersModalDetails?.data?.filter(eachStudent => {
        if(eachStudent.class === classValue.value && eachStudent.section === sectionValue.value){
            let isMatched = false
            eachStudent.termFee.map(eachObject => {
                if((eachObject[Object.keys(eachObject)[0]].paymentStatus === paymentStatusValue.value) && Object.keys(eachObject)[0] === termValue.value){
                    isMatched = true
                }
            })
            if(isMatched){
                return eachStudent
            }
        }
    })

    const onClickSave = () => {
        if(!classValue?.value){
            setClassError(true)
        }else if(!sectionValue?.value){
            setSectionError(true)
            setClassError(false)
        }else if(!paymentStatusValue?.value){
            setPaymentStatusError(true)
            setSectionError(false)
            setClassError(false)
        }else if(!termValue?.value){
            setTermError(true)
            setPaymentStatusError(false)
            setSectionError(false)
            setClassError(false)
        }
        else{
            setFilteredStudents(filteredStudents)
            setShowFiltersModal(false)
            setClassError(false)
            setSectionError(false)
            setTermError(false)
            setPaymentStatusError(false)
            setClassValue("")
            setSectionValue("")
            setPaymentStatusValue("")
            setTermValue("")
            setIsClassSelected(false)
            setIsSectionSelected(false)
            setIsPaymentStatusSelected(false)
        }
    }

    const onClickCancel = () => {
        setShowFiltersModal(!showFiltersModal);
        setClassValue("");
        setSectionValue("");
        setPaymentStatusValue("");
        setTermValue("")
        setIsClassSelected(false);
        setIsSectionSelected(false);
        setIsPaymentStatusSelected(false);
        setClassError(false);
        setSectionError(false);
        setPaymentStatusError(false);
        setTermError(false)
    }


    return (
        <Modal size="md" show={showFiltersModal} onHide={onClickCancel}  scrollable>
                <Modal.Header closeButton>
                    <Modal.Title> <p style={{padding:0, margin:0, color:"#333333", fontFamily:["Helvetica", "sans-serif"], fontSize:"20px"}}>Select Filter</p></Modal.Title>
                </Modal.Header>
                <Modal.Body style={{minHeight:'200px'}}>
                {/* <div className="form-group">
                    <label className="control-label" htmlFor="students">Select Classes</label>
                    <Select
                        maxMenuHeight='200px'
                        options={classValues}
                        isClearable={true}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isMulti
                        value={classes}
                        onChange={(selected) => {
                            selected.length &&
                            selected.find((option) => option.value === "all")
                            ? handleChangeClasses(classValues.slice(1))
                            : !true
                            ? handleChangeClasses((selected && selected.value) || null)
                            : handleChangeClasses(selected);
                        }}
                        styles={customStyles}
                        minHeight="100px"
                        />

                </div>
                <div className="form-group">
                        <label className="control-label" htmlFor="students">Select Sections</label>
                        <Select
                            maxMenuHeight='200px'
                            options={sectionValues}
                            isClearable={true}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isMulti
                            value={sections}
                            onChange={(selected) => {
                                selected.length &&
                                selected.find((option) => option.value === "all")
                                ? handleChangeRollNos(sectionValues.slice(1))
                                : !true
                                ? handleChangeRollNos((selected && selected.value) || null)
                                : handleChangeRollNos(selected);
                            }}
                            styles={customStyles}
                            minHeight="100px"
                            />

                </div> */}

                <div className="form-group">
                    <label className="control-label" htmlFor="students">Select Classes</label>
                    <Select
                        maxMenuHeight='155px'
                        options={classOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={classValue}
                        styles={customStyles}
                        minHeight="100px"
                        onChange={onChangeClass}
				    />
                </div> 
                {/* <div className='form-group'>
                    <label className="control-label" htmlFor="classes">Select Classes</label>
                    <select style={{ backgroundImage: 'none' }} value={classValue} onChange={onChangeClass} className="form-control"  id='class' name='class' required>
                        <option disabled selected hidden value="" >Select The Class</option>
                        {uniqueClasses?.map((eachClass,i) => {
                            return <option key={i} value={eachClass}>{eachClass}</option>
                        })}
                    </select>
                </div> */}
                {classError && <p style={{color:"red"}}>Please Select a Class</p>}

                {isClassSelected && 
                <div className="form-group">
                    <label className="control-label" htmlFor="students">Select Sections</label>
                    <Select
                        maxMenuHeight='100px'
                        options={sectionOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={sectionValue}
                        styles={customStyles}
                        minHeight="100px"
                        onChange={onChangeSection}
				    />
                </div> }
                {/* 
                {isClassSelected && 
                    <div className='form-group'>
                        <label className="control-label" htmlFor="classes">Select Sections</label>
                        <select style={{ backgroundImage: 'none' }} value={sectionValue} onChange={onChangeSection} className="form-control"  id='section' name='section' required>
                            <option disabled selected hidden value="" >Select The Section</option>
                            {uniqueSections?.map((eachSection,i) => {
                                return <option key={i} value={eachSection}>{eachSection}</option>
                            })}
                        </select>
                    </div>
                } */}
                {sectionError && <p style={{color:"red"}}>Please Select a Section</p>}

                {isSectionSelected && <div className="form-group">
                    <label className="control-label" htmlFor="students">Select Payment Status</label>
                    <Select
                        maxMenuHeight='100px'
                        options={paymentStatusOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={paymentStatusValue}
                        styles={customStyles}
                        minHeight="100px"
                        onChange={onChangePaymentStatus}
				    />      
                </div>}
                {paymentStatusError && <p style={{color:"red"}}>Please Select Payment Status</p>}

                {isPaymentStatusSelected && termOptions.length > 0 && <div className="form-group">
                    <label className="control-label" htmlFor="students">Select Term</label>
                    <Select
                        maxMenuHeight='100px'
                        options={termOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={termValue}
                        styles={customStyles}
                        minHeight="100px"
                        onChange={onChangeTerm}
				    />      
                </div>}
                {termError && <p style={{color:"red"}}>Please Select Term</p>}
                {(!termOptions.length > 0 && isPaymentStatusSelected) && <p style={{color:'red'}}>No Students Matched</p>}

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClickCancel}>
                        Cancel
                    </Button>
                    <Button variant="primary" disabled={!termOptions.length > 0 && isPaymentStatusSelected} onClick={onClickSave}>Save</Button>
                </Modal.Footer>
            </Modal>
      )
}

export default FiltersModal